module.exports = __webpack_public_path__ + "static/img/bg-tit3.95b74294.webp";